<template>
  <div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        :modal="false"
        v-dialogDrag
        :before-close="handleClose"
        :close-on-click-modal="false"
        :show-close="true"
        :close-on-press-escape="false"
         
        
      >
      <div style="display: flex;flex-direction: row;height: 100%;">
        <div style="flex:1">
          <!-- <el-input v-model="search" placeholder="请输入内容"></el-input> -->
          <div class="fujian"
                  v-if="nodeDataList.length != 0"
                  style="width: 100%;display: flexbox;height: 95%;">
                  <el-tree
                    :props="defaultProps"
                    :load="loadNode"
                    lazy>
                  <div slot-scope="{ node, data }">
                    <span>{{ data.fileName }}</span>
                    <span style="position: absolute;right: 10px;">
                      <el-button
                        type="primary"
                        size="mini"
                        circle
                        icon='el-icon-download'
                        @click="() => downloadFile(node)">
                      </el-button>
                      <el-button
                        type="success"
                        circle
                        size="mini"
                        icon="el-icon-delete"
                        @click="() => deletesfile(node)">
                  
                      </el-button>
                    </span>
                  </div>
                  </el-tree>
          </div> 
          

        </div>
        <el-divider direction="vertical" style="width: 2px;height: 100%;" v-if="isVisible"></el-divider>
        <div style="flex:1" v-loading="loading"  element-loading-text="文件正在上传中，请稍后..." v-if="isVisible">
          <div style="height: 90%;">
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                action=""
                multiple
                :on-remove="handleRemove"
                :on-change="changes"
                :show-file-list="false"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">选择文件夹上传</div>
              </el-upload>
              <!-- 上传文件夹列表回显 -->
              <div
                class="fujian"
                v-if="fileList.length != 0"
                style="width: 100%;display: flexbox;overflow: auto;height: 75%;"
              >
                <ul>
                  <li v-for="(item, i) in fileList" :key="i" style="line-height: 28px">
                    <div style="text-align: left;display: flex;flex-direction: row;justify-content: space-between;">
                      <div>{{ item.webkitRelativePath }}</div>
                      <div><el-button
                        type="success"
                        icon="el-icon-delete"
                        circle
                        @click="deletesfilesss(i, item)"
                        class="btnmargin"
                      ></el-button></div>
                    </div>
                  </li>
                </ul>
              </div>       
          </div>          
          <div style="height: 10%;margin-top: 15px;">
            <span style="float: right;">
            <el-button round @click="empty()" type="warning">取消</el-button>    
            <el-button round type="primary" @click="save()">保 存</el-button>
          </span>
          </div>
        </div>       
    </div>
      </el-dialog>
  </div>
</template>

<script>
import { selectYdbAttachPath,deleteYdbAttachFile } from "@/api/api";
import axios from "axios";
let date = new Date();
const currentFdate =
  date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
export default {
  props: {
    mystate: Array,
    title: '',
    isHiddenUploadDiv:{  
      type: Boolean,  
      default: true  
    },
    dirName: ''
  },
  computed: {  
    isVisible() {  
      return this.isHiddenUploadDiv;  
    }  
  },
  data() {
    return {
      states: "",
      dialogVisible: true,
      urlsss: "/userApi/ydb/basic/uploadAttach",
      fileList: [], // 附件
      filetabledata: [], // 回显附件
      pdffiledata: [], // pdf回显
      fileUrl: "",
      downloadUrl: "/userApi/minio/downloadFile",
      loading: false,
      finishedFileList:[],
      failedFileList:[],
      nodeDataList:[],
      defaultProps: {
          label: 'fileName',
          isLeaf: function (data) {
                    const { isDir } = data;
                    if (isDir) {
                      return false;
                    } else {
                      return true;
                    }
    },
        },
      search:''
    };
  },
  created() {
    if(this.dirName==''){
      this.$nextTick(() => {
            this.$refs.upload.$children[0].$refs.input.webkitdirectory = true
      })
      this.getuploadedFolder();
    }else{
      let params = {
        filterFileName: this.dirName
      };
      this.getuploadedFolder(params);
    }
      
  },
  methods: {
    save(){
      this.loading = true;
      if (this.fileList.length !== 0) {       
        const uploads = this.fileList.map(file => this.uploadFile(file));
        Promise.all(uploads).then((res)=>{         
          console.log("所有请求都完成后，执行这里的代码", res);
          this.$message({
                message: '文件夹上传成功！',
                type: 'success'
              });
          this.loading = false;
          this.nodeDataList = [];
          this.fileList = [];
          this.getuploadedFolder();
          // this.$emit('folderimportcancel');          
        }).catch(err => {
        // 处理上传请求的错误
        console.error(err);
        // this.$notify({
        //   title: "提示",
        //   message: "文件夹上传失败",
        //   type: "error"
        // });
      });       
      } else {
        
      }
      //另一种上传方法
      // this.loading = true;      
      // // 上传发出的请求列表
      // let fileRequests = []; 
      // let config = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
      //   }
      // };
      // //循环文件列表上传
      // this.fileList.forEach(file => {         
      //     //定义FormData格式的参数
      //     let formData = new FormData();
      //     // formData.append('folder', 'album'); //假设上传到服务器上指定的album文件夹下
      //     formData.append('file', file);

      //     //axios接收到FormData格式的参数，自动使用Content-Type: multipart/form-data方式上传
      //     let fileRequest = axios.post(this.urlsss, formData, config)
      //         .then(function (response) {
      //             return response.data;
      //         })
      //         .catch(function (error) {
      //             return error
      //         });             
      //     //把上传请求加入列表
      //     fileRequests.push(fileRequest); 
      // });

      // //所有请求完成结果
      // Promise.all(fileRequests).then((response) => {
      //     //所有请求都完成后，执行这里的代码
      //     console.log("所有请求都完成后，执行这里的代码", response);
      //     this.$message({
      //           message: '文件夹上传成功！',
      //           type: 'success'
      //         });
      //     this.loading = false;
      //     this.$emit('folderimportcancel')
      // }).catch((error) => {
      //     console.log(error);
      // })
    },
    uploadFile(file) {
      return new Promise((resolve, reject) => {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
        }
      };
      const formData = new FormData();
      formData.append('file', file);
      
      axios.post(this.urlsss, formData, config).then(res => {
        this.finishedFileList.push(file);
        resolve(res.data)
      }).catch(err => {
        this.failedFileList.push(file);
        reject(err)
      });
    });
    },
    //获取上传成功的文件夹列表
    getuploadedFolder(params) {
     return new Promise((resolve,reject)=>{
      selectYdbAttachPath(params).then(res => {
        if (res.code === 200) {
          // 处理PDF列表数据
          resolve(res.data)
          this.nodeDataList = res.data;
        } else if(res.code === 20000){
          this.$notify({
            title: '提示',
            message: res.message,
            type: 'warning'
          });

        } 
        else {
          // PDF列表获取失败的逻辑
          this.$notify({
            title: "提示",
            message: res.message,
            type: "error"
          });
        }
      })
      .catch(pdfListErr => {
        // 处理获取PDF列表请求的错误
        // console.error(pdfListErr);
        // this.$notify({
        //   title: "提示",
        //   message: "获取PDF列表请求失败",
        //   type: "error"
        // });
      });
    }); 
    },
    deletesfilesss(index, item) {
      // 显示确认删除的弹窗
      this.$confirm("确认删除此文件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.fileList.splice(index, 1);
        
        });
    },

    handleRemove(file, fileList) {
      // 删除文件
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.name == this.fileList[i].name) {
          this.fileList.splice(this.fileList[i], 1);
        }
      }
    },
    changes(file, fileList) {
      let num = 1024.0;

      // 检查文件大小
      // if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 50) {
      //   fileList.splice(fileList.length - 1, 1);
      //   this.$message.error("选择文件大于50M，请重新选择！");
      // } else {
        this.fileList.push(file.raw);
      // }
    },
    empty() {
      this.$emit("folderimportcancel");
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("folderimportcancel");
    },

    async downloadFile(node) {
      let fileName = '';
      let fileList = await this.getAllParents(node,[]);     
        fileList.forEach(item=>{
          fileName = item.data.fileName+'/'+fileName;
        })
      let path = fileName ? (fileName+node.data.fileName) : (node.data.fileName);
      let downloadName =  node.data.isDir ? path :path.split('.')[0];
      let params = {
        path: path
      };
      // 构建请求URL，包含Access-Token
      const url = `/userApi/ydb/basic/downloadYdbAttachFile`;
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        "Access-Token": this.$store.state.token
      };
      axios.get(url, {
        method: "GET",
        headers,
        params,
        responseType: "blob" // 设置响应类型为blob
        
      }).then(res => {
          // 创建一个虚拟的链接元素，模拟点击下载
          const link = document.createElement("a");
          let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          link.href = window.URL.createObjectURL(blob1);
          
          link.download = downloadName+'.zip'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link);
          // 模拟点击
          link.click();
          // 移除虚拟链接元素
          document.body.removeChild(link);
         
        })
        .catch(error => console.error("下载失败：", error));
    },
    async deletesfile(node) {
      // 删除文件
      let fileList = await this.getAllParents(node,[]);
      let fileName = '';
      fileList.forEach(item=>{
        fileName = item.data.fileName+'/'+fileName;
      })
      let params = {
        path: fileName ? (fileName+node.data.fileName) : (node.data.fileName),
        type: node.data.isDir ? 0 : 1
      };
      deleteYdbAttachFile(params).then(res => {
        if (res.code == 200) {
          this.$notify({
            message: res.message,
            type: "success"
          });
          this.nodeDataList = [];
          this.getuploadedFolder(); 
        }
      });
    },
    async loadNode(node, resolve) {
        if (node.level == 0) {
          let treeData='';
          if(this.dirName==''){
            treeData = await this.getuploadedFolder();
          }else{
            let params = {
                filterFileName: this.dirName
            };
            treeData = await this.getuploadedFolder(params);
          }
          return resolve(treeData);
        } else {
          let fileList = await this.getAllParents(node,[]);
          let fileName = '';
            fileList.forEach(item=>{
              fileName = item.data.fileName+'/'+fileName;
            })
          let params = {
            fileName: fileName ? (fileName+node.data.fileName) : (node.data.fileName)
          }
          let treeData = await this.getuploadedFolder(params);
          return resolve(treeData);
        }
    },
    getAllParents(node, parents = []) {    
      return new Promise((resolve,reject)=>{
        if (node && node.parent && node.parent.data) {
            parents.push(node.parent);
            resolve(this.getAllParents(node.parent, parents));
          } else {
            resolve(parents) 
          }
      })
    }   

  },
};
</script>

<style scoped="scoped">
>>> .el-dialog {
  width: 80%;
}

>>> .el-dialog__body {
  height: 450px;
  /* overflow: auto; */
}

.treebox {
  width: 100%;
  margin: 0;
}

.trees {
  width: 98%;
  float: left;
  max-height: 300px;
  height: 60px;
  line-height: 30px;
  padding-left: 2%;
  margin-top: 5px;
}

.fujian {
  width: calc(100% - 112px);
  width: -webkit-calc(100% - 112px);
  width: -moz-calc(100% - 112px);
  float: right;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
}

.tp {
  width: calc(100% - 132px);
  float: right;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
}

.addSpan {
  line-height: 30px;
  margin-right: 10px;
}
.el-divider--vertical{
  height: 100%;
}
</style>
